
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-instagram",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.932 31H3.728C2.364 30.828 1.342 29.8 1 28.428V3.743C1.17 2.371 2.193 1.342 3.557.999h24.715c1.364.171 2.387 1.2 2.727 2.571v24.857c-.17 1.2-1.193 2.229-2.387 2.572h-.681zM4 13v13.32c0 .674.511 1.18 1.192 1.18h21.116c.681 0 1.192-.506 1.192-1.18V13h-2.895c.34 1.349.511 2.529.34 3.878s-.511 2.529-1.362 3.709c-.681 1.18-1.533 2.023-2.725 2.866-2.895 2.023-6.641 2.192-9.707.337a8.978 8.978 0 01-3.576-3.541c-1.192-2.36-1.532-4.721-.681-7.25H3.999zm11.581-3.5c-3.378 0-5.912 2.704-6.081 5.915 0 3.38 2.703 6.085 5.912 6.085 3.378 0 6.081-2.704 6.081-5.915.169-3.211-2.534-6.085-5.912-6.085zm9.338-1h1.451c.645 0 1.129-.532 1.129-1.242V4.242c0-.71-.484-1.242-1.129-1.242h-2.742c-.645 0-1.129.532-1.129 1.242v3.371c.162.532.645.887 1.129.887h1.291z"}})])
          )
        }
      }
    